/**
 * @fileoverview Component for displaying a link expired message.
 * This component includes a message indicating that the link is expired and provides a link to request a new link.
 */

import { ArrowRightIcon } from '@heroicons/react/20/solid'
import { NavLink } from 'react-router-dom'
import NovoicDashboardLogo from '../../assets/novoic-dashboard-logo.svg'

/**
 * @function LinkExpired
 * @description Component for displaying a link expired message.
 * @returns {JSX.Element} - A React component that renders the link expired message.
 */
export default function LinkExpired() {
    return (
        <div className="nv-grid min-h-screen">
            <div className="md-container max-h-full items-center content-center justify-center col-start-1 md:col-start-2 lg:col-start-5">
                <div className="w-full max-w-md space-y-8">
                    <div className="flex flex-col items-center gap-y-4">
                        <NovoicDashboardLogo className="w-56" />
                        <h2 className="text-center text-3xl font-bold font-serif text-gray-900">
                            Password reset link expired
                        </h2>

                        <p className="text-gray-600 font-regular text-center">
                            This link is no longer valid, as it may have been used already or
                            because more than 24 hours have passed since it was issued.
                        </p>
                    </div>
                    <div className="flex justify-center items-center">
                        <NavLink
                            to="/password/request"
                            className="inline-flex gap-x-1 px-2 py-1 rounded-md transition-all text-indigo-600 hover:bg-indigo-50"
                        >
                            <span className="font-medium text-sm">Request Another Link</span>
                            <ArrowRightIcon className="w-5 h-5 stroke-indigo-600" />
                        </NavLink>
                    </div>
                </div>
            </div>
        </div>
    )
}
